module.exports = __webpack_public_path__ + "static/assets/d72b98474fc83d6268886779339e242e.mp3";